import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 77.9 80.1",
  "content": "<symbol viewBox=\"0 0 77.9 80.1\" id=\"user\">\n\t<path d=\"M39,50.1c6.2,0,11.5-2.4,15.8-7.3c4.4-4.9,6.6-10.8,6.6-17.7c0-6.9-2.2-12.8-6.6-17.7C50.4,2.4,45.2,0,39,0\n\t\tS27.5,2.4,23.1,7.3c-4.4,4.9-6.6,10.8-6.6,17.7c0,6.9,2.2,12.8,6.6,17.7C27.5,47.6,32.8,50.1,39,50.1L39,50.1z M39,50.1\" />\n\t<path d=\"M77.4,62.3C76.8,60.1,76,58,74.9,56c-1-2.1-2.3-3.8-3.6-5.3c-1.4-1.5-3-2.6-5-3.5c-2-0.9-4.1-1.3-6.5-1.3\n\t\tc-0.3,0-1.2,0.5-2.4,1.4c-1.3,0.9-2.7,2-4.3,3.1c-1.6,1.2-3.7,2.2-6.3,3.1c-2.6,0.9-5.2,1.4-7.8,1.4c-2.6,0-5.2-0.5-7.8-1.4\n\t\tc-2.6-0.9-4.7-2-6.3-3.1c-1.6-1.1-3.1-2.2-4.3-3.1c-1.3-0.9-2.1-1.4-2.4-1.4c-2.4,0-4.5,0.4-6.5,1.3c-2,0.9-3.6,2-5,3.5\n\t\tC5.3,52.1,4,53.9,3,56c-1.1,2.1-1.9,4.2-2.5,6.4c-0.6,2.2-1.1,10.3,1.7,13.3c2.8,3,6.6,4.5,11.3,4.5h51c4.7,0,8.5-1.5,11.3-4.5\n\t\tC78.6,72.6,78.1,64.5,77.4,62.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user.svg
// module id = 124
// module chunks = 1